import InvestmentFinalizePage from "./InvestmentFinalizePage"

export default InvestmentFinalizePage
